export default "__VITE_ASSET__D3OE7Lj2__"